export const LogoMark = ({ size = 34 }) => (
  <img src="/logo-mark.png" alt="Swiftwire logo" width={size} height={size} className="object-contain" />
);

export const Logo = () => (
  <img src="/logo-full.png" alt="Swiftwire Payments" className="h-9 w-auto" data-testid="swiftwire-logo" />
);

export default Logo;
